import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  EditButton,
  Filter,
  Resource,
} from "react-admin";

// Server-side search: the value goes out as ?search= (see dataProvider getList) and
// the backend filters by article category / material application name (ILIKE).
const WeightSharesFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);

// Feature 1 (weights): default weight `share` (0..1) of each material application
// within an article category, plus `isMandatory`. Editable in place — changes apply
// to NEW calculations only (the weight assumption is order-independent).
const WeightSharesList = (props) => (
  <List {...props} perPage={50} bulkActionButtons={false} filters={<WeightSharesFilters />}>
    <div style={{ marginTop: "15px" }}>
      <Datagrid rowClick="edit">
        <TextField source="articleCategory" label="Article category" />
        <TextField source="materialApplication" label="Material application" />
        <NumberField source="share" label="Share" />
        <BooleanField source="isMandatory" label="Mandatory" />
        <NumberField source="categoryTotalWeight" label="Category total weight (kg)" />
        <EditButton />
      </Datagrid>
    </div>
  </List>
);

const EditWeightShare = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="articleCategory" label="Article category" disabled />
      <TextInput source="materialApplication" label="Material application" disabled />
      <NumberInput source="share" label="Share (0..1)" step={0.01} />
      <BooleanInput source="isMandatory" label="Mandatory" />
    </SimpleForm>
  </Edit>
);

const weightSharesResource = () => (
  <Resource
    name="weightShares"
    options={{ label: "Weight shares", menuGroup: "Bcome" }}
    list={WeightSharesList}
    edit={EditWeightShare}
  />
);

export default weightSharesResource;
